import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/3QZowYSZuYmiszX4zfxvvf/ChatGPT_Image_17_may_2026,_16_23_22-Photoroom.webp';
// Only preconnect to the CDN that serves the LCP hero — drop font CDN preconnects
// (fonts load async with system-font fallback, Lighthouse warns at >4 preconnects)
const preconnectCdn = document.createElement('link');
preconnectCdn.rel = 'preconnect';
preconnectCdn.href = 'https://cdn.magicpatterns.com';
document.head.appendChild(preconnectCdn);
// Preload LCP hero image with HIGH fetch priority
const preloadHero = document.createElement('link');
preloadHero.rel = 'preload';
preloadHero.as = 'image';
preloadHero.href = HERO_IMAGE;
preloadHero.type = 'image/webp';
(preloadHero as any).fetchPriority = 'high';
document.head.appendChild(preloadHero);
// Load Google Fonts NON-BLOCKING after first paint to keep critical path lean
const loadFonts = () => {
  const fontLink = document.createElement('link');
  fontLink.rel = 'stylesheet';
  fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Outfit:wght@700;800;900&display=swap';
  fontLink.media = 'print';
  fontLink.onload = () => {
    fontLink.media = 'all';
  };
  document.head.appendChild(fontLink);
};
if ('requestIdleCallback' in window) {
  ;
  (window as any).requestIdleCallback(loadFonts, {
    timeout: 2000
  });
} else {
  setTimeout(loadFonts, 1000);
}
render(<App data-id="element-313" />, document.getElementById('root'));